import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/product/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';
import { downloadProductOfferingKeyMappingsCSV } from '../../../../util/mac/downloadCSV';

export const orderableItemByAccountId = (accountId: number, state: State) =>
  fetchWithParamValidation(({ id }) => getFromHamsClient(`/orderableitem/account/${id}`, state), {
    id: accountId,
  });

export const getProductPackagesByKeys = async (keys: string[], state: State) =>
  fetchWithParamValidation(
    ({ productKeys }) => getFromHamsClient(`/byKey?keys=${productKeys}`, state),
    {
      productKeys: keys.join(','),
    },
  );

export const getEvaluationProducts = async (state: State) =>
  fetchWithParamValidation(() => getFromHamsClient(`/evaluation`, state), {});

export const getCurrentProductPackage = async (productKey: string, state: State) =>
  fetchWithParamValidation(({ key }) => getFromHamsClient(`/byKey/${key}/current`, state), {
    key: productKey,
  });

export const getBTFProductAvailableForEvaluation = async (addonKey: string, state: State) => {
  return fetchWithParamValidation(({ key }) => getFromHamsClient(`/evaluation/btf/${key}`, state), {
    key: addonKey,
  });
};

export const getProductPackageById = async (productPackageId: number, state: State) => {
  return fetchWithParamValidation(({ id }) => getFromHamsClient(`/byId/${id}`, state), {
    id: productPackageId,
  });
};

export const getProductOfferingKeyMappings = async (state: State) => {
  fetchWithParamValidation(async () => {
    const response = await getFromHamsClient(`/productOfferingKeyMappings`, state);
    if (response) {
      downloadProductOfferingKeyMappingsCSV(response);
    }
  }, {});
};
